import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'

export const renderListItem = (primary: string, secondary: string, sx: any = {}) => {
	const primaryTextElement = <>{primary}</>
	const secondaryTextElement = <>{secondary}</>

	return (
		<ListItem sx={sx.root} disableGutters disablePadding>
			<ListItemText primary={primaryTextElement} secondary={secondaryTextElement} sx={sx.text} />
		</ListItem>
	)
}
